// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__1Qesb","box--gray":"Box_box--gray__2-_5O","box--primary":"Box_box--primary__1Y9oB","box--boxRadius":"Box_box--boxRadius__3sHt_"};